<div class="modal fade" id={{modelId}} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-scrollable" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            {{modalName}}
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal" (click)="onCancelClick()">
                </div>
                <hr>
                <div>
                    <div class="modal-form">
                        <form [formGroup]="reservationTypeForm" #data>
                            <div class="row firstMainRow">
                                <div class="col-2" style="font-size: 14px;  padding-right: 0; padding-left: 0; ">
                                    <div class="rightInput imageContainer">
                                        <img class="zoneImages"
                                            [src]="profileURl == '' && reservationTypeForm.controls['thumbnail'].value == null ? '../../../../../assets/images/addPhoto.png' : profileURl != '' ? profileURl : reservationTypeForm.controls['thumbnail'].value" />
                                        <input type="file" class="custom-file-input fileInput editIcon" id="customFile"
                                            name="myfile" (change)="addImage($event)" #UploadFileInput
                                            accept="image/png, image/jpeg" />
                                        <img class="editIcon" href="#customFile"
                                            src="../../../../../assets/icons/editBackgroundpng.png" />
                                    </div>
                                </div>
                                <div class="col-4 inputColTwin"
                                    style="font-size: 14px;  padding-right: 0; padding-left: 0; ">
                                    <div class="rightInput">
                                        <label class="lblInput" for="fontWeight">Name</label><span
                                            style="color: red;">*</span>
                                        <input type="text" class="form-control input" placeholder="Name"
                                            formControlName='name' style="height: 52px; font-size: 14px;"
                                            [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.name.errors}">
                                    </div>
                                    <div *ngIf="submitted && reservationTypeFormControls.name.errors"
                                        class="text-danger">
                                        Name is required
                                    </div>
                                </div>
                                <div class="col-4 inputColTwin"
                                    style="font-size: 14px;  padding-right: 0; padding-left: 0; ">
                                    <div class="rightInput">
                                        <label class="lblInput" for="fontWeight">Description</label><span
                                            style="color: red;">*</span>
                                        <textarea type="text" class="form-control textarea"
                                            formControlName='description' placeholder="Description"
                                            [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.description.errors}"
                                            style="height: 42px; font-size: 14px;"></textarea>
                                    </div>
                                    <div *ngIf="submitted && reservationTypeFormControls.description.errors"
                                        class="text-danger">
                                        Description is required
                                    </div>
                                </div>
                            </div>
                            <div class="row mainRow">
                                <div class="col col-8 mainSections marginTop">
                                    <div class="col col-12">
                                        <h5 class="headingText">Manually Confirm</h5>
                                        <h5 class="descText">If choose zone it will follow the rules defined under zone,
                                            if it’s yes force manual confirmation
                                            regardless of zone rules, if it’s No other way around. </h5>
                                    </div>
                                </div>
                                <div class="col col-3 actionContainer marginTop">
                                    <select class='custom-select' formControlName="manual_confirmation"
                                        data-style="dropdownCustomStyle"
                                        (change)="selectManualConfirm($event.target.value)">
                                        <option selected value="" disabled
                                            data-content="<span class='text-secondary'>Nothing Selected</span>">Nothing
                                            Selected
                                        </option>
                                        <option *ngFor="let type of manualConfirmTypes" (value)="type.value">
                                            {{type.name}} </option>
                                    </select>
                                </div>
                                <div *ngIf="submitted && reservationTypeFormControls.manual_confirmation.errors"
                                    class="text-danger">
                                    Manual Confirmation is required
                                </div>
                            </div>
                            <div class="row mainRow">
                                <div class="col col-11 mainSections marginTop">
                                    <div class="col col-8">
                                        <h5 class="headingText">Force a deposit payment</h5>
                                        <h5 class="descText">Enabled: Customer is required to pay a deposit when making
                                            the booking</h5>
                                    </div>
                                </div>
                                <div class="col col-1 actionContainer marginTop">
                                    <ui-switch size="small" switchColor="white" color="#00c10b" defaultBgColor="white"
                                        uncheckedLabel="Off" checkedLabel="On" checkedTextColor="white"
                                        (changeEvent)="updateSwitch('force_deposit')"
                                        [(ngModel)]="reservationType.force_deposit"
                                        [ngModelOptions]="{standalone: true}" defaultBoColor="#cccccc">
                                    </ui-switch>
                                </div>
                            </div>
                            <div class=" mainRow" style="margin-top: 10px;" *ngIf="reservationType.force_deposit">
                                <div class="col col-11 mainSections marginTop" style="border-left: 5px solid #0B4791;">
                                    <div class="col-3 col-left columnContainer">
                                        <label class="headingText">Amount £</label>
                                        <input class="form-control" type="number" placeholder="Amount"
                                            formControlName='deposit_amount'
                                            [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.deposit_amount.errors}">
                                        <div class="text-danger">
                                            <div class=""
                                                *ngIf="submitted && reservationTypeFormControls.deposit_amount.errors">
                                                Amount is required </div>
                                        </div>
                                    </div>

                                    <div class="col col-3 col-left columnContainer">
                                        <label class="headingText">Deposit Type</label>
                                        <select class="custom-select mr-sm-2" formControlName="deposit_type"
                                            style=" font-size: 14px;" id="inlineFormCustomSelect"
                                            [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.deposit_type.errors}">
                                            <option value='PER_HEAD' selected>PER_HEAD</option>
                                            <option value="TABLE">TABLE</option>
                                        </select>
                                        <div class="text-danger">
                                            <div *ngIf="submitted && reservationTypeFormControls.deposit_type.errors">
                                                Deposit type is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col col-4 col-left columnContainer">
                                        <label class="headingText">Customer Refundable?</label>
                                        <select class="custom-select mr-sm-2" formControlName="is_refundable"
                                            style=" font-size: 14px;" id="inlineFormCustomSelect"
                                            [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.is_refundable.errors}">
                                            <option value=1 selected>Yes</option>
                                            <option value=0>No</option>
                                        </select>
                                        <div class="text-danger">
                                            <div *ngIf="submitted && reservationTypeFormControls.is_refundable.errors">
                                                Customer Refundable is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mainRow">
                                <div class="col col-8 mainSections marginTop">
                                    <div class="col col-12">
                                        <h5 class="headingText">Maximum Party Size</h5>
                                        <h5 class="descText">Maximum party size that allocated to this reservation type
                                        </h5>
                                    </div>
                                </div>
                                <div class="col col-3 actionContainer marginTop">
                                    <input type="number" placeholder="Maximum Party Size" class="form-control input"
                                        formControlName="max_party_size" style="height: 52px; font-size: 14px;"
                                        [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.max_party_size.errors}">

                                </div>
                                <div class="text-danger"
                                    *ngIf="submitted && reservationTypeFormControls.max_party_size.errors">
                                    Maximum Party Size is required
                                </div>
                            </div>
                            <div class="row mainRow">
                                <div class="col col-8 mainSections marginTop">
                                    <div class="col col-12">
                                        <h5 class="headingText">Allocated Zones</h5>
                                        <h5 class="descText">Allocate the zones to this reservation type</h5>
                                    </div>
                                </div>
                                <div class="col col-3 actionContainer marginTop">
                                    <select class='form-control bulkInput selectpicker' id="spicker_zones"
                                        (click)="selectZones()" (ngModelChange)="selectZones()" formControlName="zones"
                                        data-style="dropdownCustomStyle" multiple>
                                        <option *ngFor="let zone of allZones" [ngValue]="zone.id">
                                            {{zone.name}}</option>
                                    </select>
                                </div>
                                <div class="text-danger" *ngIf="submitted && reservationTypeFormControls.zones.errors">
                                    <div>Zone is Required</div>
                                </div>
                            </div>
                            <div class="row mainRow">
                                <div class="col col-8 mainSections marginTop">
                                    <div class="col col-12">
                                        <h5 class="headingText">Reservation Type Availability</h5>
                                        <h5 class="descText">Select simple, schedule or repeat available time for
                                            this
                                            reservation type</h5>
                                    </div>
                                </div>
                                <div class="col col-3 actionContainer marginTop">
                                    <select class='custom-select' id="spicker_types" formControlName="availability_type"
                                        data-style="dropdownCustomStyle" (ngModelChange)="onRTypeChange($event)">
                                        <option selected value='' disabled
                                            data-content="<span class='text-secondary'>Nothing Selected</span>">Nothing
                                            Selected
                                        </option>
                                        <option *ngFor="let type of reservationTypes" [ngValue]="type.value">
                                            {{type.name}} </option>
                                    </select>
                                </div>
                                <div class="text-danger"
                                    *ngIf="submitted && reservationTypeFormControls.availability_type.errors">
                                    <div>
                                        Reservation Type Availability is required
                                    </div>
                                </div>
                            </div>
                            <div class="row mainRow" formGroupName="duration"
                                *ngIf="reservationTypeFormControls['availability_type'].value == 'SIMPLE'">
                                <div class="col col-12" style="margin-top: 5px;">
                                    <p class="alert alert-info " style="font-size: 14px; margin: 0px;">Setting a
                                        general times will be accessible for all days</p>
                                </div>
                                <div class="col col-12 mainSections marginTop" *ngFor="let times of allDurations">
                                    <div class="col col-5">
                                        <label>Start Time </label>
                                        <input type="time" formControlName={{times.start_time}} placeholder="Start Time"
                                            class="form-control time-input" step="1800" min='00:00'
                                            [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.duration.get(times.start_time).errors}"
                                            style="height: 44px; font-size: 14px;">
                                        <div class="text-danger">
                                            <div
                                                *ngIf="submitted && reservationTypeFormControls.duration.get(times.start_time).errors">
                                                Start time is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col col-6">
                                        <label>End Time</label>
                                        <input type="time" formControlName={{times.end_time}} placeholder="End Time"
                                            class="form-control time-input" step="1800" min='00:00'
                                            [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.duration.get(times.end_time).errors}"
                                            style="height: 44px; font-size: 14px;">
                                        <div class="text-danger">
                                            <div
                                                *ngIf="submitted && reservationTypeFormControls.duration.get(times.end_time).errors">
                                                End time is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mainRow"
                                *ngIf="reservationTypeFormControls['availability_type'].value == 'SCHEDULE'">
                                <div class="col col-12" style="margin-top: 5px;">
                                    <p class="alert alert-info " style="font-size: 14px; margin: 0px;">Schedule a
                                        reservation type for a particular date and different times</p>
                                </div>
                                <div class="col col-12 mainSections marginTop">
                                    <div class="col col-5">
                                        <label>Start Date</label><span style="color: red;">*</span>
                                        <input type="date" formControlName="start_date" placeholder="Start Date"
                                            class="form-control input" style="height: 52px; font-size: 14px;"
                                            [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.start_date.errors}">
                                        <div class="text-danger">
                                            <div *ngIf="submitted && reservationTypeFormControls.start_date.errors">
                                                Start date is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col col-6">
                                        <label>End Date</label><span style="color: red;">*</span>
                                        <input type="date" placeholder="End Date" formControlName="end_date"
                                            class="form-control input" style="height: 52px; font-size: 14px;"
                                            [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.end_date.errors}">
                                        <div class="text-danger">
                                            <div *ngIf="submitted && reservationTypeFormControls.end_date.errors">
                                                End date is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 mainSections marginTop" formGroupName="duration">
                                    <div class="col col-11">
                                        <div class="inputFieldContainer" *ngFor="let times of allDurations">
                                            <div class="col col-5" style="font-size: 14px; ">
                                                <div class="">
                                                    <label class="lblInput" for="fontName">Start Time</label><span
                                                        style="color: red;">*</span>
                                                    <input type="time" formControlName={{times.start_time}}
                                                        placeholder="Start Time" class="form-control time-input"
                                                        step="1800" min='00:00' style="height: 44px; font-size: 14px;"
                                                        [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.duration.get(times.start_time).errors}">
                                                    <div class="text-danger">
                                                        <div
                                                            *ngIf="submitted && reservationTypeFormControls.duration.get(times.start_time).errors">
                                                            Start time is required
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class=" col col-5" style="font-size: 14px; ">
                                                <div class="leftInput">
                                                    <label class="lblInput" for="fontName">End Time</label><span
                                                        style="color: red;">*</span>
                                                    <input type="time" formControlName={{times.end_time}}
                                                        placeholder="End Time" class="form-control time-input"
                                                        step="1800" min='00:00' style="height: 44px; font-size: 14px;"
                                                        [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.duration.get(times.end_time).errors}">
                                                    <div class="text-danger">
                                                        <div
                                                            *ngIf="submitted && reservationTypeFormControls.duration.get(times.end_time).errors">
                                                            End time is required
                                                        </div>
                                                        <div class=""></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col col-1"
                                                style=" display: flex; justify-content: flex-end; align-items: flex-end;">
                                                <button class="btn rightInput"
                                                    [ngClass]="times.id > 0 ? 'deleteButtonActive' : 'deleteButton'"
                                                    type="button" (click)="deleteTimeDurations(times)">
                                                    <img src="../../../../../assets/icons/trash-upload.png" width="18px"
                                                        height="18px" class="d-inline-block align-top" alt=""
                                                        loading="lazy">
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" col-1" style="display: flex; align-self: end;">
                                        <button class="btn rightInput addValues" type="button"
                                            (click)="addTimeDurations()">
                                            <img src="../../../../../assets/icons/addDeliveryInfo.png" width="18px"
                                                height="18px" class="d-inline-block align-top" alt="" loading="lazy">
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row mainRow"
                                *ngIf="reservationTypeFormControls['availability_type'].value == 'REPEAT'">
                                <div class="col col-12" style="margin-top: 5px;">
                                    <p class="alert alert-info " style="font-size: 14px; margin: 0px;">Select days
                                        that
                                        should repeat your scheduled reservation type</p>
                                </div>
                                <div class="col col-12 mainSections marginTop">
                                    <div class="col col-5">
                                        <label>Start Date</label>
                                        <input type="date" formControlName="start_date" placeholder="Start Date"
                                            class="form-control input" style="height: 52px; font-size: 14px;"
                                            [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.start_date.errors}">
                                        <div class="text-danger">
                                            <div *ngIf="submitted && reservationTypeFormControls.start_date.errors">
                                                Start date is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col col-6">
                                        <label>End Date</label>
                                        <input type="date" formControlName="end_date" placeholder="End Date"
                                            class="form-control input" style="height: 52px; font-size: 14px;"
                                            [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.end_date.errors}">
                                        <div class="text-danger">
                                            <div *ngIf="submitted && reservationTypeFormControls.end_date.errors">
                                                End date is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 mainSections marginTop" formGroupName="duration">
                                    <div class="col col-11">
                                        <div class="inputFieldContainer" *ngFor="let times of allDurations">
                                            <div class="col col-5" style="font-size: 14px; ">
                                                <div class="">
                                                    <label class="lblInput" for="fontName">Start Time</label><span
                                                        style="color: red;">*</span>
                                                    <input type="time" formControlName={{times.start_time}}
                                                        placeholder="Start Time" class="form-control time-input"
                                                        step="1800" min='00:00' style="height: 44px; font-size: 14px;"
                                                        [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.duration.get(times.start_time).errors}">
                                                    <div class="text-danger">
                                                        <div
                                                            *ngIf="submitted && reservationTypeFormControls.duration.get(times.start_time).errors">
                                                            Start time is required
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class=" col col-5" style="font-size: 14px; ">
                                                <div class="leftInput">
                                                    <label class="lblInput" for="fontName">End Time</label><span
                                                        style="color: red;">*</span>
                                                    <input type="time" formControlName={{times.end_time}}
                                                        placeholder="End Time" class="form-control time-input"
                                                        step="1800" min='00:00' style="height: 44px; font-size: 14px;"
                                                        [ngClass]="{ 'is-invalid': submitted && reservationTypeFormControls.duration.get(times.end_time).errors}">
                                                    <div class="text-danger">
                                                        <div
                                                            *ngIf="submitted && reservationTypeFormControls.duration.get(times.end_time).errors">
                                                            End time is required
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col col-1"
                                                style=" display: flex;justify-content: flex-end;align-items: flex-end;">
                                                <button class="btn rightInput"
                                                    [ngClass]="times.id > 0 ? 'deleteButtonActive' : 'deleteButton'"
                                                    type="button" (click)="deleteTimeDurations(times)">
                                                    <img src="../../../../../assets/icons/trash-upload.png" width="18px"
                                                        height="18px" class="d-inline-block align-top" alt=""
                                                        loading="lazy">
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                    <div class=" col-1" style="display: flex;  align-self: end;">
                                        <button class="btn rightInput addValues" type="button"
                                            (click)="addTimeDurations()">
                                            <img src="../../../../../assets/icons/addDeliveryInfo.png" width="18px"
                                                height="18px" class="d-inline-block align-top" alt="" loading="lazy">
                                        </button>
                                    </div>
                                </div>
                                <div class="col col-12 mainSections marginTop">
                                    <div class="col col-12">
                                        <label>Select Active Days</label>
                                        <div class="row checkboxContainer">
                                            <div class="col col-3" *ngFor="let value of availableDays"
                                                style="display: flex; align-items: center;">

                                                <input (change)="selectDay(value, $event)" type="checkbox"
                                                    placeholder="Select Active Days" class="form-control "
                                                    [checked]="value.isChecked">

                                                <div class="col-10">
                                                    <label class="dates">{{value.day}}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-12 modal-button-div">
                        <button class="btn modal-btn-button" type="button"
                            (click)="modalType == 'Add' ? onAddClick() : onEditClick()">
                            <span *ngIf="!loading">{{modalType == 'Edit' ? 'Save' : 'Add Type'}}</span>
                            <div *ngIf="loading" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>